<div class="dealer-list-item" (click)="goToDealerDetails()">
  <i *ngIf="!dealer.profileImage" class="icofont-user-alt-7"></i>
  <img *ngIf="dealer.profileImage" [src]="dealer.profileImage">
  <div class="dealer-details">
    <div class="dealer-name">{{ dealer.lastName }} {{ dealer.firstName }}</div>
    <div class="dealer-address">{{ dealer.street }}, {{ dealer.city }}</div>
  </div>
  <button (click)="showDealerBooks($event)">ספרים</button>
</div>